import { Box, Chip, useTheme } from '@mui/material'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { DrawArea } from '@app/redux/riskMap/riskMapSlice'
import { RootState } from '@app/redux/store'

/**
 * Renders a "Filter:" chip row summarising the geographic filters saved on a
 * workspace (custom drawn area and/or named regions). Renders nothing when
 * there are no filters. Region codes are resolved to display names via the
 * Redux available-regions list, falling back to the raw code.
 */
export const WorkspaceFilterChips = ({
  regions,
  drawAreas,
}: {
  regions?: string[] | null
  drawAreas?: DrawArea[]
}) => {
  const theme = useTheme()
  const availableRegions = useSelector((state: RootState) => state.riskMap.regions)

  const filterLabels = useMemo(() => {
    const labels: string[] = []
    if (drawAreas?.length) labels.push('Custom area')
    if (regions?.length) {
      for (const code of regions) {
        const match = availableRegions.find((r) => r.region === code)
        labels.push(match?.region_name ?? code)
      }
    }
    return labels
  }, [drawAreas, regions, availableRegions])

  if (filterLabels.length === 0) return null

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '4px', alignItems: 'center' }}>
      <Box sx={{ fontSize: '0.85rem', fontWeight: 600, color: theme.palette.text.secondary }}>
        Filter:
      </Box>
      {filterLabels.map((label) => (
        <Chip key={label} label={label} size="small" />
      ))}
    </Box>
  )
}
